import {useEffect} from "react"
import HomeHeader from "../sections/home-header/HomeHeader"
import HomeContent from "../sections/home-content/HomeContent"
import {useNavigate} from "react-router-dom"
import {useSessionContext} from "../reactContext/contextCustomHooks/useSessionContext"

export default function Home() {
    const {sessionContext} = useSessionContext()
    let navigate = useNavigate()

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
    })

    return (
        <>
        <div className="VIEW HOME">
            <HomeHeader/>
            <span className="line"></span>
            <HomeContent/>
        </div>
        </>
    )
}